import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ServerPricing from '../../homepage/header-banner/ServerPricing';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
// import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBoxRow from '../../container/Box/Components/CardBox-Row'
import CommonTable from '../../container/Table/Components/CommonTable';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import BannerPrivateCloudENG from '../../container/Banner/banner-privateCloud-en';
import Cloudconsult2ENG from '../../homepage/consult/cloudconsult-2-en';
import SidebarENG from '../../container/Sidebar/Sidebar-en';
import HeaderEn from '../../detailpageVN/Page/component/headeren';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;


// Titlecloudcompute
function MonitoringVolumeENG() {
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudENG />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarENG />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("모니터링•볼륨 구조")} */}
                        {/* {Contentcloudcard("고성능 Local SSD replication Volume 적용 안정적인 서비스운영","모든 인스턴스에 물리적인 rCPU (1배수) 적용, 고용량의 메모리제공")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12} className='Grid-card'>{CardBoxRow(
                                "<p class='typo-21-sm typo-medium typo-black'>Private Kubernetes Monitoring Detailed Structure</p>",

                                `
                                <p class='typo-14'>The Private Kubernetes system supports real-time monitoring of pod status and enables rapid fault handling.</p>
                                
                                <p class='typo-14'>Data modified by the monitoring pod is stored for a specific period in Hanbit Object Storage, which is used to generate logs and various metrics.</p>
                                
                                <p class='typo-14'>Pod statuses are monitored in real-time; upon failure, notifications are sent via push or email to engineers for swift resolution.</p>

                                `)}</MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} className='Grid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/back-office-2.png")}</MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12} className='Grid-card'>{CardBoxRow(
                                "Operation of Persistent Volumes in Private Kubernetes",

                                `
                                <p class='typo-14'>The default specification for Private Kubernetes uses local volumes.</p>
                                
                                <p class='typo-14'>High-performance N/V is achieved through openEBS or HostPath volume recognition.</p>
                                
                                <p class='typo-14'>Supports eternal scalability, enabling streaming capabilities.</p>
                                `)}</MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} className='Grid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/monitoring-volume-2.png")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>
                        <Cloudconsult2ENG />
                    </Col>
                </Row>
            </Container>


            <FooterEn />
        </Sysfont>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default MonitoringVolumeENG;